import axiosInstance from "auth/FetchInterceptor";
import { PHIEU_TANG_GIAM_NHAN_SU_API } from "constants/ApiConstant";
const baseUrl = process.env.REACT_APP_HRM_ENDPOINT_URL;

const PhieuTangGiamNhanSuService = {};

 
  PhieuTangGiamNhanSuService.searchGrid = (data) => {
    return axiosInstance.post(`${PHIEU_TANG_GIAM_NHAN_SU_API}/search-grid`, data, {
        baseURL: baseUrl,
      });
  };

  PhieuTangGiamNhanSuService.getById = (id) => {
    return axiosInstance.get(`${PHIEU_TANG_GIAM_NHAN_SU_API}/detail/${id}`, {
        baseURL: baseUrl,
      });
  };

  PhieuTangGiamNhanSuService.create = (data) => {
    return axiosInstance.post(`${PHIEU_TANG_GIAM_NHAN_SU_API}/create`, data);
  };

  PhieuTangGiamNhanSuService.update = (data) => {
    return axiosInstance.put(`${PHIEU_TANG_GIAM_NHAN_SU_API}/update`, data);
  };

  PhieuTangGiamNhanSuService.delete = (id) => {
    return axiosInstance.delete(`${PHIEU_TANG_GIAM_NHAN_SU_API}/delete/${id}`, {
      baseURL: baseUrl,
    });
  };

  PhieuTangGiamNhanSuService.counts = (data) => {
    return axiosInstance.post(`${PHIEU_TANG_GIAM_NHAN_SU_API}/counts`, data, {
      baseURL: baseUrl,
    });
  };

  PhieuTangGiamNhanSuService.exportExcel = (data) => {
    return axiosInstance.post(`${PHIEU_TANG_GIAM_NHAN_SU_API}/export-excel`, data, {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  };

  PhieuTangGiamNhanSuService.getHistoryQuaTrinhHanhNghe = (employeeId) => {
    return axiosInstance.get(`${PHIEU_TANG_GIAM_NHAN_SU_API}/list-qua-trinh-hanh-nghe/${employeeId}`, {
      baseURL: baseUrl,
    });
  };

export default PhieuTangGiamNhanSuService;
